import { makeAutoObservable } from 'mobx';

export type LivestreamStatus = 'live' | 'unknown';

export interface YoutubeLivestreamProviderData {
    url: string;
}

export interface YoutubeLivestream {
    status: LivestreamStatus;
    provider: 'youtube';
    stream_url: string;
}

// todo: example provider for mux
export interface MuxLivestream {
    status: LivestreamStatus;
    provider: 'mux';
    data: { mux: string };
}

type GenericLivestream = YoutubeLivestream | MuxLivestream;

export interface LivestreamProvider {
    recent_livestream?: GenericLivestream;
}

class LivestreamStore {
    active: GenericLivestream | null = null;

    constructor() {
        makeAutoObservable(this);
    }

    get isWatchingLivestream() {
        return this.active !== null;
    }

    start(stream: GenericLivestream) {
        this.active = stream;

        const target = document.querySelector('#hero-switcher');

        if (target) {
            window.scrollTo({
                top: target.getBoundingClientRect().top + window.scrollY,
                behavior: 'smooth',
            });
        }
    }

    stop() {
        this.active = null;
    }
}

export const livestreamStore = new LivestreamStore();
